import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

const zupAccessChange = async (params: { uuid: string; access: boolean }) => {
  const { uuid, access } = params;

  const payload = { user: { zup_access: access } };

  return await postRequest(API.POST.zupAccess(uuid), payload);
};

export const useZupAccessChange = () => {
  const client = useQueryClient();
  const { handleError } = useMessageHandler();

  return useMutation({
    mutationFn: zupAccessChange,
    onSuccess: () =>
      client.invalidateQueries({ queryKey: [QUERY_KEYS.CANDIDATE] }),
    onError: handleError,
  });
};
